import { useMutation } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import {
  updateDefaultProcessStep,
  UpdateDefaultProcessStepResponseDto,
} from "#modules/defaultProcessSteps/infra/updateDefaultProcessStep.api";

export const useUpdateDefaultProcessStep = (options?: {
  onSuccess?: (updateDefaultProcessStep: UpdateDefaultProcessStepResponseDto) => void;
}) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: updateDefaultProcessStep,
    onSuccess: (defaultProcessStep) => {
      if (!defaultProcessStep) {
        return;
      }
      options?.onSuccess?.(defaultProcessStep);
    },
    onError: (err) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { updateDefaultProcessStep: mutate, ...rest };
};
